export const ListQueryKey = 'activityRecommends';
export const DetailQueryKey = 'activityRecommend';
export const Urls = {
  selectUrl: '/activityRecommend/list',
  updateUrl: '/activityRecommend/update',
  deleteUrl: '/activityRecommend/delete',
  createUrl: '/activityRecommend/create',
  detailUrl: '/activityRecommend/detail'
};